/**
 * The base button fro the UI.
 * Comes with visibility and alert states baked in.
 * @module StyledButton
 * @category Display Components
 */
import { styled } from "styled-components";
import { SDK_Fonts } from "../gql/generated/operations.js";
import { colors } from "../lib/ui.js";

export const defaultButtonTheme = {
  backgroundColor: colors.white,
  borderColor: colors.black,
  color: colors.black,
  font: "Gill Sans",
  fontSize: 1,//rem - base font size is 1rem
  height: 2,//rem - base font size is 1rem
  hoverColor: colors.brand.blue,
  minWidth: { landscape: "3rem", portrait: "5rem" },
  emphasize: colors.brand.yellow,
  alert: colors.red,
  borderBlockEnd: 0,
  borderInlineEnd: 0,
  borderInlineStart: 0,
  borderBlockStart: 0,
}



export const StyledButton = styled.button<{
  $emphasize?: boolean;
  $portrait?: boolean,
  alert?: boolean;
  hide?: boolean;
  $fonts?: SDK_Fonts
}>`
  appearance: none;
  padding: 0; /* Adjust as needed */
  margin: 0; /* Adjust as needed */
  align-items:center;
  background-color: ${props => props.$emphasize ? props.theme.emphasize : props.theme.background};
  border-radius: 3px;
  border-color: ${props => props.theme.borderColor ? props.theme.borderColor : defaultButtonTheme.borderColor};
  border-inline-start: ${props => props.theme.borderInlineStart ? props.theme.borderInlineStart : defaultButtonTheme.borderInlineStart}px solid;
  border-inline-end: ${props => props.theme.borderInlineEnd ? props.theme.borderInlineEnd : defaultButtonTheme.borderInlineEnd}px solid;
  border-block-end: ${props => props.theme.borderBlockEnd ? props.theme.borderBlockEnd : defaultButtonTheme.borderBlockEnd}px solid;
  border-block-start: ${props => props.theme.borderBlockStart ? props.theme.borderBlockStart : defaultButtonTheme.borderBlockStart}px solid;
  color: ${props => props.theme.color};
  cursor: pointer;
  font-size: ${props => props.theme.fontSize + "rem"};
  font-family: Gill Sans;
  display: flex;
  height: ${props => props.theme.height + "rem"};
  width: ${props => props.theme.width};
  justify-content: center;
  margin: 1rem;
  padding: 1rem;
  text-align: center;
  visibility: ${props => (props.hide ? "hidden" : "visible")};
  min-width: ${props => props.$portrait ? defaultButtonTheme.minWidth.portrait : defaultButtonTheme.minWidth.landscape};
  &:hover {
  background-color: ${props => props.theme.hoverColor ? props.theme.hoverColor : defaultButtonTheme.hoverColor};
  transition: background-color 0.3s ease-in-out;
}
`;


StyledButton.defaultProps = {
  theme: defaultButtonTheme,
}